<template>
    <div style="width: 100%;">
        <div style="
        width: 100%;
        background-color: var(--color-steel-100);
        padding: var(--spacing-6);
        position: relative;
        "
        id="passwordTip"
        >
            <div style="display:flex; flex-wrap: nowrap; flex-direction: row;">
                <patternlib-headline :headline="$t('passwordTip.headline')" heading-tag="h3" separator="none"></patternlib-headline>
                <div 
                id="placeholder"
                style="
                    min-width: calc(72px - (var(--spacing-6)) + 15px);              
                    min-height: calc(72px - 18px);
                "
                >
                </div>
            </div>
            <ul style="list-style-type: disc; margin-left: var(--spacing-6); margin-top: var(--spacing-4);">
                <li v-html="$t('passwordTip.tipOne')"></li>
                <li v-html="$t('passwordTip.tipTwo')"></li>
                <li v-html="$t('passwordTip.tipThree')"></li>
            </ul>

            <div style="
                width: 72px;
                height: 72px;
                background-color: var(--color-artic-blue);
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                position: absolute;
                top: -18px;
                right: 0px;
            "
            >
                <patternlib-icon icon-name="info-circle" size="40px" style="color: var(--color-white);"></patternlib-icon>
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>

@media only screen and (max-width: 770px) { 
    #passwordTip {
        padding-top: 64px !important;
    }

}
</style>